/**
 * Discount Code Copy to Clipboard
 * Handles copying discount codes with visual feedback
 */

document.addEventListener('DOMContentLoaded', function() {
  const copyButtons = document.querySelectorAll('[data-copy-code]');

  copyButtons.forEach(button => {
    const copyCode = function(e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
      }

      e.preventDefault();

      const code = button.dataset.copyCode;
      const originalText = button.querySelector('.copy-text').textContent;

      // Copy to clipboard
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => {
          showCopiedFeedback(button, originalText);
        }).catch(() => {
          fallbackCopyTextToClipboard(code, button, originalText);
        });
      } else {
        fallbackCopyTextToClipboard(code, button, originalText);
      }
    };

    button.addEventListener('click', copyCode);
    button.addEventListener('keydown', copyCode);

    // Add hover hint
    button.setAttribute('title', 'Click to copy code');
  });
});

function showCopiedFeedback(button, originalText) {
  const textEl = button.querySelector('.copy-text');

  // Fade out original text
  textEl.classList.add('fading');

  // Wait for fade out, then change text and fade in
  setTimeout(() => {
    textEl.textContent = 'Copied!';
    textEl.classList.remove('fading');
  }, 250);

  // Reset after 2 seconds
  setTimeout(() => {
    // Fade out "Copied!"
    textEl.classList.add('fading');

    // Wait for fade out, then restore original text and fade in
    setTimeout(() => {
      textEl.textContent = originalText;
      textEl.classList.remove('fading');
    }, 250);
  }, 2000);
}

function fallbackCopyTextToClipboard(text, button, originalText) {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    showCopiedFeedback(button, originalText);
  } catch (err) {
    console.error('Failed to copy text: ', err);
  }

  document.body.removeChild(textArea);
}

// For Shopify section re-rendering (theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const copyButtons = event.target.querySelectorAll('[data-copy-code]');
    copyButtons.forEach(button => {
      button.setAttribute('title', 'Click to copy code');
    });
  });
}
